<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLiveStream_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3.545 3h8.91C13.86 3 15 4.205 15 5.692v5.385c0 1.487-1.14 2.692-2.546 2.692H3.545C2.14 13.77 1 12.564 1 11.077V5.692C1 4.205 2.14 3 3.545 3m7.572 5.947a.5.5 0 0 0 0-.893L6.726 5.836A.5.5 0 0 0 6 6.282v4.437a.5.5 0 0 0 .726.446z"
        clip-rule="evenodd"
    />
</svg>
